import React from "react";
import image1 from './assets/PicturesOfMe/IMG_0545.JPG'

const Picture = () => {
  return <img src={image1} alt="Andrew Lanpouthakoun" className="photo" />;
};

export default Picture;
